import EmblaCarousel from "embla-carousel";
import magicLine from "../helpers/magic-line";

(() => {
	const serviceCarousel = document.querySelectorAll(".m04");
	const options = {
		draggable: true,
	};

	const magicLineInstance = new magicLine(".m04__list", {
		navElements: "button",
		lineStrength: 2,
	});
	magicLineInstance.init();

	serviceCarousel.forEach((carousel) => {
		const viewport = carousel.querySelector(".m04__wrapper");

		if (viewport === null) {
			return;
		}

		const embla = EmblaCarousel(viewport, options);
		const activeButtons = carousel.getElementsByClassName("active");
		const navigationButtons = carousel.querySelectorAll(".m04__nav-button");
		const mobileSelect = carousel.querySelector(".m04__select");

		embla.on("resize", () => embla.reInit({ breakpoints: { "(min-width: 1040px)": { draggable: true } } }));
		embla.on("select", (e) => {
			while (activeButtons[0]) {
				activeButtons[0].blur();
				activeButtons[0].classList.remove("active");
			}
			navigationButtons[embla.selectedScrollSnap()].classList.add("active");

			let mq = window.matchMedia("(min-width: 810px)");

			if (mq.matches) {
				let event = new MouseEvent("mouseover", {
					view: window,
					bubbles: true,
					cancelable: true,
				});

				navigationButtons[embla.selectedScrollSnap()].dispatchEvent(event);
			}
		});

		navigationButtons.forEach((button) => {
			button.addEventListener("click", () => {
				embla.scrollTo(button.getAttribute("data-index"));
			});
		});

		if (mobileSelect !== null) {
			mobileSelect.addEventListener("input", (e) => {
				embla.scrollTo(e.target.value);
			});
		}
	});
})();
